import CourseBreadcrumbs from './CourseBreadcrumbs';

export default CourseBreadcrumbs;
